// @flow
import React, { type Node } from 'react';
import { I18n } from '@lingui/react';

import LabelAndErrorFormGroup from '@rover/react-lib/components/utils/LabelAndErrorFormGroup';
import TextInput from '@rover/react-lib/components/formFields/TextInput';

export type Props = {};

const StripeCreditCardNameField = ({ ...other }: Props): Node => (
  <I18n>
    {({ i18n }) => (
      <LabelAndErrorFormGroup
        {...other}
        label={i18n._('Name on Card')}
        name="cc-name"
        autoComplete="cc-name"
        data-qa-id="credit-card-inputs-name"
      >
        {inputProps => <TextInput {...inputProps} />}
      </LabelAndErrorFormGroup>
    )}
  </I18n>
);

export default StripeCreditCardNameField;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/StripeCreditCardForm/StripeCreditCardNameField.jsx